// extracted by mini-css-extract-plugin
export var change = "_41-1";
export var changeList = "_41-0";
export var changePath = "_41-2";
export var diffArrow = "_41-5";
export var diffRow = "_41-3";
export var diffValue = "_41-4";
export var error = "_41-8";
export var notice = "_41-9";
export var result = "_41-6";
export var success = "_41-7";